var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 81 81",
    style: {
      enableBackground: "new 0 0 81 81"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,58.5v18c0,2.5,2,4.5,4.5,4.5h45c2.5,0,4.5-2,4.5-4.5v-72C81,2,79,0,76.5,0l-45,0C29,0,27,2,27,4.5v18 c0,2.5,2,4.5,4.5,4.5h0c2.5,0,4.5-2,4.5-4.5v-9C36,11,38,9,40.5,9h27C70,9,72,11,72,13.5v54c0,2.5-2,4.5-4.5,4.5h-27 C38,72,36,70,36,67.5v-9c0-2.5-2-4.5-4.5-4.5h0C29,54,27,56,27,58.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9,36h45L41.4,23.4c-2-2-0.6-5.4,2.2-5.4h0c0.8,0,1.7,0.3,2.2,0.9l13.9,13.9c2,2,3.2,4.8,3.2,7.7v0c0,2.9-1.1,5.6-3.2,7.7 L45.9,62.1c-0.6,0.6-1.4,0.9-2.2,0.9h0c-2.8,0-4.3-3.4-2.2-5.4L54,45H9c-2.5,0-4.5-2-4.5-4.5v0C4.5,38,6.5,36,9,36z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.a6b6ad3ccdc8a465b0662e1de175c09e.svg";
export { ForwardRef as ReactComponent };